// extracted by mini-css-extract-plugin
export default {"cls1":"ResearchInterestSearchResults-cls1__fN","cls2":"ResearchInterestSearchResults-cls2__MU ResearchInterestSearchResults-cls1__fN"};